module.exports = __webpack_public_path__ + "media/images/icons/outlined/number-340d4a44865fefe913b882fe4df4b2c1.svg";